'use strict';require('../../style/css');
require('../../list/style/css');
require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/textarea-item/style/css.web.js
// module id = 306
// module chunks = 0